var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.333 1.514v2.753c0 .374 0 .56.072.703a.667.667 0 0 0 .292.291c.142.073.329.073.702.073h2.754m.18 1.325v4.808c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H5.866c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.427-.218-.988-.218-2.108V4.534c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.428-.218.988-.218 2.108-.218h2.141c.49 0 .734 0 .964.055a2 2 0 0 1 .578.24c.202.123.375.296.72.642l2.126 2.126c.346.346.52.519.643.72.11.18.19.374.24.579.055.23.055.474.055.963z",
    stroke: "#5786CC",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPdf);
export default __webpack_public_path__ + "static/media/upload-pdf.16971e6f52d3820c705730de8af25a78.svg";
export { ForwardRef as ReactComponent };